import { render, staticRenderFns } from "./add-custom-ind.vue?vue&type=template&id=64d7a602&scoped=true&"
import script from "./add-custom-ind.vue?vue&type=script&lang=ts&"
export * from "./add-custom-ind.vue?vue&type=script&lang=ts&"
import style0 from "./add-custom-ind.vue?vue&type=style&index=0&id=64d7a602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7a602",
  null
  
)

export default component.exports